export function buildExportUrl(params: {
  search?: string;
  organizationId?: string;
  type: 'park-and-ride-facilities' | 'parking-facilities';
}) {
  const sp = new URLSearchParams();
  if (params.search?.trim()) sp.set('search', params.search.trim());
  if (params.organizationId) sp.set('organizationId', params.organizationId);
  const qs = sp.toString();

  return `/api/${params.type}/export.csv${qs ? `?${qs}` : ''}`;
}
